import {ChangeEvent, useEffect, useState} from 'react';
import { HexColorPicker, HexColorInput } from 'react-colorful';
import {Input} from '@shortsworks/ui/index';
import {cn} from '@shortsworks/ui/lib/utils';

interface ColorPickerProps {
  color: string;
  onColorChange: (color: string) => void;
  disableGradient?: boolean;
  className?: string;
  showTitle?: boolean;
}

export function ColorPicker({ color, onColorChange, className, showTitle = true }: ColorPickerProps) {
  const [ colorValue, setColorValue ] = useState<string>(color);

  useEffect(() => {
    setColorValue(color);
  }, [color]);

  const handleChangeColor = (hex: string) => {
    setColorValue(hex);
    onColorChange(hex);
  }

  const handleInput = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setColorValue(value);
    onColorChange(value);
  }

  return (
    <div
      className={cn(
        'w-full p-[18px]',
        className,
      )}
    >
      <div className="w-full">
        <HexColorPicker
          className="!w-full"
          color={colorValue}
          onChange={handleChangeColor}
        />
      </div>
      <div className="w-full mt-4">
        <div
          className={cn(
            "relative flex items-center h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors",
            "file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground",
            "focus-within:outline-none focus-within:ring-1 focus-within:ring-ring",
            "disabled:cursor-not-allowed disabled:opacity-50 pl-7",
            "before:content-['#'] before:flex before:items-center before:justify-center before:absolute before:w-6 before:h-full " +
            "before:text-foreground before:-inset-x-[1px] before:bg-input before:rounded-tl-md before:rounded-bl-md before:border-none"
          )}
        >
          <HexColorInput
            className="border-none outline-none w-full h-full text-sm"
            color={colorValue}
            onChange={handleChangeColor}
          />
        </div>
      </div>
    </div>
  )
}
